import apiService from "../../../services/api";
import {
  CompanyListParams,
  CompanyListPayload,
} from "../model/company_management_model";

export const CompanyManagementApi = {
  getCompanies: async (
    params: CompanyListParams,
  ): Promise<CompanyListPayload> => {
    const response = await apiService.get("/admin/billing/companies", params);
    const data = response.data || {};

    return {
      subscriptions: data.subscriptions || [],
      total: data.total || 0,
      has_more: Boolean(data.has_more),
      total_active: data.total_active || 0,
      total_trial: data.total_trial || 0,
      total_cancelled: data.total_cancelled || 0,
      total_past_due: data.total_past_due || 0,
      total_expired: data.total_expired || 0,
    };
  },

  updateCompanyStatus: async (companyId: string, active: boolean) =>
    apiService.updateAdminCompanyStatus(companyId, active),
};
